export default {
  currentBlogCotent(state) {

  }
}
